import { Component, OnInit, HostBinding } from '@angular/core';
import { ElementService, ElementDataImport } from '../../service/element.service';
import { ImportField } from '../../service/import-param';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
	selector: 'common-import-field',
	templateUrl: './import-field.component.html',
	styleUrls: ['./import-field.component.scss']
})
export class ImportFieldComponent implements OnInit {
	@HostBinding('class.c-import-field') hostClass = true;
	public svr = this.elementSvr.data.import as ElementDataImport;
	titles = ['åºå·', 'åç§°', 'å«å', 'ç±»å«', 'å¼', 'å¤æ³¨'];
	constructor(public elementSvr: ElementService) {}

	drop(event: CdkDragDrop<ImportField[]>) {
		moveItemInArray(this.svr.Params.Fields, event.previousIndex, event.currentIndex);
	}

	ngOnInit() {
		// console.log(this.svr.Params.Fields);
	}
}
